import { DisclaimerFields, DisclaimerProps } from "../types/Disclaimer.type"

export class DisclaimerModel {
  private readonly fields?: DisclaimerFields

  constructor(props: DisclaimerProps) {
    this.fields = props.fields
  }
}
